import React from 'react';
import { useSelector } from 'react-redux';
import { selectWebsiteTheme } from '../../store/slices/website';

import { Container } from './styled';

const CLSeparator = () => {
  const { colors } = useSelector(selectWebsiteTheme);

  return (
    <Container color={colors[3].color} />
  );
};

export default CLSeparator;
